const DEFAULT_TOPICS = []

const ASSIST_SCREEN_TOPICS = [
  {
    screen: 'Drip campaigns',
    match: pathname => pathname === '/custom-campaigns' || pathname === '/custom-campaigns/',
    topics: [
      {
        label: 'Plan a local staycation',
        message:
          'I\'d like to run a staycation campaign targeting locals who have stayed with us before.'
      },
      {
        label: 'Make messages sound like us',
        message:
          'Before we write any campaigns, I want the tone to match our brand. Our website is silveradoresort.com.'
      }
    ]
  },
  {
    screen: 'Analytics',
    match: pathname =>
      pathname.startsWith('/analytics') ||
      pathname.startsWith('/monthly-revenue') ||
      pathname.startsWith('/monthly-ota-conversions') ||
      pathname.startsWith('/messaging-performance') ||
      pathname.startsWith('/roi'),
    topics: []
  },
  {
    screen: 'Campaigns',
    match: pathname =>
      pathname.startsWith('/manageCampaigns') ||
      pathname.startsWith('/editCampaign') ||
      pathname.startsWith('/editDefaultCampaign') ||
      pathname.startsWith('/defaultCampaigns') ||
      pathname.startsWith('/publish-campaign') ||
      pathname.startsWith('/campaign-analysis'),
    topics: []
  },
  {
    screen: 'Health check',
    match: pathname => pathname.startsWith('/healthCheck'),
    topics: []
  },
  {
    screen: 'Occupancy',
    match: pathname =>
      pathname.startsWith('/occupancy') || pathname.startsWith('/site-abandonment'),
    topics: [
      {
        label: 'Soft weekend after Labor Day',
        message:
          "I'm looking at my occupancy report and the weekend after Labor Day is really soft. I need to do something fast."
      }
    ]
  },
  {
    screen: 'Announcements',
    match: pathname => pathname.startsWith('/announcements'),
    topics: []
  },
  {
    screen: 'Guest messaging',
    match: pathname =>
      pathname.startsWith('/messaging') ||
      pathname.startsWith('/incoming') ||
      pathname.startsWith('/feedback') ||
      pathname.startsWith('/direct') ||
      pathname.startsWith('/chatbot-responses') ||
      pathname.startsWith('/dailyConversations'),
    topics: []
  },
  {
    screen: 'Billing',
    match: pathname => pathname.startsWith('/billing') || pathname.startsWith('/transaction'),
    topics: []
  },
  {
    screen: 'Bookings',
    match: pathname =>
      pathname.startsWith('/bookings') ||
      pathname.startsWith('/gds-bookings') ||
      pathname.startsWith('/arrivals'),
    topics: [
      {
        label: 'Corporate group cancelled',
        message:
          'We just had a corporate group cancel on us. I need to fill those dates fast.'
      }
    ]
  },
  {
    screen: 'Reviews',
    match: pathname => pathname.startsWith('/reviews'),
    topics: []
  },
  {
    screen: 'Hotel setup',
    match: pathname =>
      pathname.startsWith('/hotel-setup') ||
      pathname.startsWith('/onboarding') ||
      pathname.startsWith('/pms') ||
      pathname.startsWith('/pms-login'),
    topics: []
  }
]

export const getAssistTopicsForPath = pathname => {
  const normalizedPath = pathname || '/'
  const matchedScreen = ASSIST_SCREEN_TOPICS.find(entry => entry.match(normalizedPath))

  if (matchedScreen) {
    return {
      screen: matchedScreen.screen,
      topics: matchedScreen.topics
    }
  }

  return {
    screen: 'Dashboard',
    topics: DEFAULT_TOPICS
  }
}

export { ASSIST_SCREEN_TOPICS, DEFAULT_TOPICS }
